import React, { useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import DeviceCaseSupportedDiagnoseList from "./DeviceCaseSupportedDiagnoseList";
import { withStyles } from '@material-ui/core/styles';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { diagnoseCaseExecutionTypesLookup, diagnoseCaseGroupsLookup } from "../../AdminDiagnoseCase";
import { createHistory, hasPermission } from "../../../sc-utilities";
import { FindInPage } from "@material-ui/icons";
import { Redirect } from "react-router-dom";
import * as actions from "../store/deviceCaseSupportedActions";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    label: {
        flexDirection: 'column'
    },
    iconText: {
        fontSize: "10px"
    }
});

const DeviceCaseSupportedDiagnoseCases = (props) => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, rowData: null, redirectPath: '' });
    const groupLookups = diagnoseCaseGroupsLookup(translations);
    const executionTypesLookups = diagnoseCaseExecutionTypesLookup(translations);
    const visible = columns && columns['DeviceCaseSupportedDiagnoseCases'];
    const tableColumns = useMemo(() => {
        return [
            {
                title: translations["actions"] || "Actions", field: 'Actions',
                hidden: visible ? visible['Actions'] : false,
                cellStyle: { minWidth: 100, maxWidth: 100 },
                filtering: false,
                render: rowData => <>
                    {
                        hasPermission(permissions, 'system_device_case_supported_update_params') ? <Tooltip title={translations["update_params"] || "Update params"}>
                            <IconButton value={rowData.Key} disabled={rowData.Key !== 'motherboard' && rowData.Key !== "keyboard"} aria-label={translations["update_params"] || "Update params"} onClick={() => redirectHandler(`/admin/device-case-supported/update-case-params`, rowData)}>
                                <FindInPage />
                            </IconButton>
                        </Tooltip> : ''
                    }
                </>
            },
            {
                title: translations["long_name"] || 'Long name', field: 'LongName',
                hidden: visible ? visible['LongName'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.LongName ? rowData.LongName : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["short_name"] || 'Short name', field: 'ShortName',
                hidden: visible ? visible['ShortName'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.ShortName ? rowData.ShortName : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["execution_type"] || 'Execution type', field: 'ExecutionType',
                hidden: visible ? visible['ExecutionType'] : false,
                filtering: true,
                filterCellStyle: { maxWidth: '150px' },
                lookup: executionTypesLookups,
                defaultFilter: Object.keys(executionTypesLookups),
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.ExecutionType ? translations[rowData.ExecutionType] || rowData.ExecutionType : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["product_type"] || 'Product type', field: 'ProductType',
                hidden: visible ? visible['ProductType'] : false,
                filtering: true,
                cellStyle: { minWidth: 100, maxWidth: 100 },
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.ProductType ? translations[rowData.ProductType] || rowData.ProductType : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["group"] || 'Group', field: 'Group',
                hidden: visible ? visible['Group'] : false,
                filtering: true,
                filterCellStyle: { maxWidth: '150px' },
                lookup: groupLookups,
                defaultFilter: Object.keys(groupLookups),
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Group ? translations[rowData.Group] || rowData.Group : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["visible"] || 'Visible', field: 'Visible',
                hidden: visible ? visible['Visible'] : false,
                filtering: true,
                lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
                defaultFilter: ['0', '1'],
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Visible ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
                }
            },
            {
                title: translations["key"] || 'Key', field: 'Key',
                hidden: visible ? visible['Key'] : true,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Key ? rowData.Key : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])

    const redirectHandler = (path, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, rowData: rowData, redirectPath: path });
    };
    if (redirectOptions.redirect) {
        return <Redirect
            to={{
                pathname: redirectOptions.redirectPath.split('?')[0], search: redirectOptions.redirectPath.split('?')[1],
                state: { redirectOptions }
            }}
        />;
    }
    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'customer_diagnose_case_list') &&
                <DeviceCaseSupportedDiagnoseList
                    tableColumns={tableColumns}
                    tableRef={tableRef}
                />
            }
        </div>
    );
}
const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onEditDeviceCaseSupportedDiagnoseCaseParams: params => dispatch(actions.editDeviceCaseSupportedDiagnoseCaseParams(params)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DeviceCaseSupportedDiagnoseCases));